export function getParasNftUrl(id) {
  return `https://paras.id/token/x.paras.near::${id}`;
}